import React, {FunctionComponent} from "react";
import InputText, {InputTextProps} from "./InputText";

type InputDomainProps = Omit<InputTextProps, "pattern">;

const InputDomain: FunctionComponent<InputDomainProps> = ({...inputAttr}) => {
    const getPattern = () => {
        return "[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,6}";
    };

    return (
        <InputText
            pattern={getPattern()}
            {...inputAttr}
        />
    );
};

export default InputDomain;
